import { DAY_MS, DRAFTING_DAYS } from "./suggestions/checkpoints"

/**
 * The weekly report's week: Monday 00:00 UTC to the next Monday, and the week before it to compare with. The page's
 * `week=` and the report read these same windows, so a figure in one is the number on the other. Client-safe.
 */

const WEEK_MS = DRAFTING_DAYS * DAY_MS
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/
const MONDAY = 1

export interface ReportWeekWindows {
  range: { start: Date; end: Date };
  prevRange: { start: Date; end: Date };
}

/** `YYYY-MM-DD` of a Monday: the only week a report is keyed to. */
export function isReportWeekStart(value: string): boolean {
  if (!DATE_ONLY.test(value)) return false
  const day = new Date(`${value}T00:00:00Z`)
  return !Number.isNaN(day.getTime()) && day.toISOString().startsWith(value) && day.getUTCDay() === MONDAY
}

export function reportWeekWindows(periodStart: string): ReportWeekWindows {
  const start = new Date(`${periodStart}T00:00:00Z`)
  const end = new Date(start.getTime() + WEEK_MS)
  return { range: { start, end }, prevRange: { start: new Date(start.getTime() - WEEK_MS), end: start } }
}

/** «5–11 Oct 2026»; the month and the year only where they change. */
export function formatReportWeek(periodStart: string): string {
  const first = new Date(`${periodStart}T00:00:00Z`)
  const last = new Date(first.getTime() + WEEK_MS - DAY_MS)
  const day = (date: Date) => date.getUTCDate()
  // en-US: «Sep», where en-GB writes «Sept».
  const month = (date: Date) => date.toLocaleString("en-US", { month: "short", timeZone: "UTC" })
  const year = (date: Date) => date.getUTCFullYear()

  if (year(first) !== year(last)) {
    return `${day(first)} ${month(first)} ${year(first)} – ${day(last)} ${month(last)} ${year(last)}`
  }
  if (month(first) !== month(last)) return `${day(first)} ${month(first)} – ${day(last)} ${month(last)} ${year(last)}`
  return `${day(first)}–${day(last)} ${month(last)} ${year(last)}`
}
